import { AbstractAdapter, Adapter } from "@app/shared/models/adapter.model";
import { Filtering, Pagination, Sortable } from "@app/shared/models/server-pagination.model";

export const UserEventTypes = {
  Login: "L",
  MenuItems: "M",
  Favorites: "F",
  OnDemand: "R",
  MyReports: "MR"
};

export interface UserEvents {
  filterUserId: string;
  filterApplicationId: string;
  filterEventType: typeof UserEventTypes;
  numberOfRecordsToSelect: number;
  userEventsList: UserEventsList[];
}

export interface UserEventsList {
  userId: string;
  applicationId: string;
  eventType: string;
  item: string;
  description: string;
  isLegacy: boolean;
  timestamp: string;
}

export interface UserEventActivity {
  userId: string;
  pagination: Pagination;
  sortable: Sortable;
  filtering: Filtering[];
  userEventsLog: UserEventActivityList[];
}

export interface UserEventActivityList {
  applicationId: string;
  eventType: string;
  item: string;
  description: string;
  timestamp: string | Date;
  _event: string;
}

export class UserEventsAdapter implements Adapter<UserEventsList[]> {
  adapt(rawData: UserEvents): UserEventsList[] {
    if (!rawData) {
      return null;
    }

    return rawData?.userEventsList;
  }
}

export class UserEventActivityRequestAdapter extends AbstractAdapter<UserEventActivity> {
  adapt(rawData: any): UserEventActivity {
    const data = this.clone(rawData);
    (data?.filtering as Filtering[])?.map((e) => {
      if (e.filterColumn === "timestamp") {
        e.filterValues = e.filterValues.map((x, i) => {
          const newDate = new Date(x);

          if (this.dateService.isValidDate(newDate)) {
            // Update timestamps to be start and end of day to get full results.
            i === 0 ? newDate.setHours(0, 0, 0, 0) : newDate.setHours(23, 59, 59, 999);
            x = this.dateService.dateToTimeStamp(newDate);
          }
          return x;
        });
      }

      return e;
    });

    return data;
  }
}

export class UserEventActivityResponseAdapter extends AbstractAdapter<UserEventActivity> {
  adapt(rawData: UserEventActivity): UserEventActivity {
    rawData.userEventsLog.map((x) => {
      switch (x.eventType) {
        case UserEventTypes.Login: {
          x._event = "USER_PROFILES.LBL_EVENT_LOGIN";
          break;
        }
        case UserEventTypes.MenuItems: {
          x._event = "USER_PROFILES.LBL_EVENT_MENU";
          break;
        }
        case UserEventTypes.Favorites: {
          x._event = "USER_PROFILES.LBL_EVENT_FAV";
          break;
        }
        case UserEventTypes.OnDemand: {
          x._event = "USER_PROFILES.LBL_EVENT_ONDEMAND";
          break;
        }
        case UserEventTypes.MyReports: {
          x._event = "USER_PROFILES.LBL_EVENT_MYREPORTS";
          break;
        }
        default: {
          x._event = "";
        }
      }

      x.timestamp = x.timestamp ? this.dateService.timeStampToDate(x.timestamp as string) : "";
    });
    return rawData;
  }
}
